'use client';

import { useTranslation } from 'react-i18next';

import { ReportEChart } from '@/app/reports/components/ReportEChart';
import type { ReportSeriesPoint } from '@/app/reports/components/report-chart-utils';

export type ReportChartKind =
  | 'line'
  | 'area'
  | 'bar'
  | 'horizontal_bar'
  | 'stacked_bar'
  | 'grouped_bar'
  | 'pie'
  | 'donut'
  | 'treemap'
  | 'funnel'
  | 'gauge'
  | 'heatmap'
  | 'waterfall'
  | 'sparkline'
  | 'combo'
  | 'metric'
  | 'table'
  | 'scatter';

type ReportChartProps = {
  kind: ReportChartKind;
  series: ReportSeriesPoint[];
  currency?: string;
  isPercentage?: boolean;
  compact?: boolean;
};

export function ReportChart({ kind, series, currency, isPercentage, compact }: ReportChartProps) {
  const { t } = useTranslation('reports');

  return (
    <ReportEChart
      kind={kind}
      series={series}
      currency={currency}
      isPercentage={isPercentage}
      compact={compact}
      valueLabel={t('viewer.value')}
    />
  );
}
